export default function Split() {
  const slider = document.querySelector('#split-slider');
  if (slider) {
    slider.addEventListener('input', (e) => {
      const sliderPos = e.target.value;
      // Update the width of the foreground image
      document.querySelector('.foreground-img').style.setProperty('height', `${sliderPos}%`);
      // Update the position of the slider button
      document.querySelector('.slider-button').style.setProperty('top', `calc(${sliderPos}% - 20px)`);
    });
  }
}
